import { LocalDiningOutlined } from '@mui/icons-material';
import React, { Suspense } from 'react';

export const RouteFallback = (Component: any) => (props: JSX.IntrinsicAttributes) => (
  <Suspense fallback={<LocalDiningOutlined />}>
    <Component {...props} />
  </Suspense>
);
